import { helpers } from '@vuelidate/validators';

/**
 * Validates postal codes.
 */
export default helpers.withParams(
  { type: 'postal', message: 'Postal code does not match the required format.' },
  value => /^[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]$/.test(value),
);
